import React from "react";
import Button from "react-bootstrap/es/Button";
import {dayMonthYearAtTime} from "../../utils/dates";
import {Col, Row} from "react-bootstrap";

class TransactionPeddingActionGrid {
  title = 'Lista de Transações esperando ação';
  showNewButton = false;
  columns = [
    {
      Header: "ID da leitura",
      accessor: "id"
    },
    {
      Header: "Data",
      accessor: "createdAt",
      Cell: row => dayMonthYearAtTime(row.original.createdAt)
    },
    {
      Header: "Ponto de Leitura",
      accessor: "readpoint.friendlyName"
    },
    {
      Header: "Ponto de Controle",
      accessor: "checkpoint.friendlyName"
    },
    {
      Header: "Total de Items",
      accessor: "transactionItems.length"
    },
    {
      Header: "Status",
      accessor: "status"
    },
    {
      Header: "Opções",
      sortable: false,
      filterable: false,
      export: false,
      Cell: row => (
          <Row>
            <Col sm={6} lg={6}>
              <a href={`#/transactions/${row.original.id}/pending`}>
                <Button bsStyle="info" block>Resolver</Button>
              </a>
            </Col>
            <Col sm={6} lg={6}>
              <a href={"#/transactions/" + row.original.id}>
                <Button bsStyle="success" block>Visualizar</Button>
              </a>
            </Col>
          </Row>
      )
    }
  ];
  endpoint = "ton/v1/transactions?status=WAIT_ACTION";
}

export default TransactionPeddingActionGrid;



// WEBPACK FOOTER //
// ./src/transaction/component/TransactionPeddingActionGrid.js